import { omit } from "radash";
import { computed } from "vue";

import type { UseButtonEmit } from "@/lib/components/logic/atoms/useButton";
import type { DefineProps } from "@/lib/composables/componentComposable";

import * as useButton from "@/lib/components/logic/atoms/useButton";
import {
  emitsDefinition,
  propsDefinition,
  propsToDefaults,
} from "@/lib/composables/componentComposable";
import { mergeReactive } from "@/lib/helpers/reactivity.ts";

const props = propsDefinition({
  icon: { type: String, required: true },
  ...omit(useButton.props, [
    "prefixIcon",
    "suffixIcon",
    "fluid",
    "textAlign",
    "checked",
  ]),
});

const emits = emitsDefinition(useButton.emits);

type UseButtonIconProps = DefineProps<typeof props>;
type UseButtonIconEmit = UseButtonEmit;

function use(props: UseButtonIconProps, emit: UseButtonIconEmit) {
  const { tag, buttonProps, click, disabled } = useButton.use(
    mergeReactive(propsToDefaults(useButton.props), props),
    emit,
  );

  const icon = computed(() =>
    props.loading ? "fa-regular fa-spinner-third fa-spin" : props.icon,
  );

  return {
    icon,
    tag,
    buttonProps,
    click,
    disabled,
  };
}

export type { UseButtonIconEmit, UseButtonIconProps };
export { emits, props, use };
